import { memo } from "react";

import { IFranchise } from "../../../models/IFranchise";

import NothingFound from "../../NothingFoundPage/NothingFound";
import CatalogFranchiseCard from "../../../UI/cards/CatalogFranchiseCard";

import classes from "./FranchiseList.module.scss";

const FranchiseList = memo(({ franchises }: { 
    franchises: IFranchise[], 
}) => {

    if (!franchises.length) return <NothingFound text="К сожалению, франшизы не найдены" />

    return (
       <section className={classes.catalog__grid}>
            {franchises.map((franchise) => (
                <CatalogFranchiseCard key={franchise.id} franchise={franchise} />
            ))}
        </section>
    );
});

export default FranchiseList;